// Styles CSS inline pour la modale embedded

export const embeddedModalStyles = `
.flipcard-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.flipcard-modal {
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 480px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.flipcard-modal-header {
  background: #2196F3;
  color: #FFFFFF;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flipcard-modal-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.flipcard-modal-close {
  background: transparent;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s;
}

.flipcard-modal-close:hover {
  background: rgba(255, 255, 255, 0.2);
}

.flipcard-modal-close i {
  font-size: 24px;
}

.flipcard-modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.flipcard-modal-field {
  margin-bottom: 20px;
}

.flipcard-modal-field:last-child {
  margin-bottom: 0;
}

.flipcard-modal-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.flipcard-modal-file-input {
  display: block;
  padding: 12px;
  border: 2px dashed #E0E0E0;
  border-radius: 8px;
  background: #F5F5F5;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.flipcard-modal-file-input:hover {
  border-color: #2196F3;
  background: #E3F2FD;
}

.flipcard-modal-file-input input[type="file"] {
  display: none;
}

.flipcard-modal-file-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #666;
  cursor: pointer;
}

.flipcard-modal-file-label i {
  font-size: 32px;
  color: #2196F3;
}

.flipcard-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #E0E0E0;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.flipcard-modal-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
}

.flipcard-modal-btn-cancel {
  background: #F5F5F5;
  color: #666;
}

.flipcard-modal-btn-cancel:hover {
  background: #E0E0E0;
}

.flipcard-modal-btn-primary {
  background: #2196F3;
  color: #FFFFFF;
}

.flipcard-modal-btn-primary:hover {
  background: #1976D2;
}

.flipcard-modal-btn-primary:disabled {
  background: #B0BEC5;
  cursor: not-allowed;
}

.flipcard-modal-preview {
  margin-top: 12px;
  border: 2px solid #E0E0E0;
  border-radius: 8px;
  padding: 12px;
  background: #F9F9F9;
  display: none;
}

.flipcard-modal-preview.visible {
  display: block;
}

.flipcard-modal-preview img {
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  border-radius: 4px;
}

.flipcard-modal-error {
  color: #F44336;
  font-size: 13px;
  margin-top: 8px;
  display: none;
}

.flipcard-modal-error.visible {
  display: block;
}
`;
